module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"I Miei Pazienti","pageMetaDescription":"-","NoPatients":"Non hai ancora pazienti"}}')
  delete Component.options._Ctor
}
